import type { Dictionary } from 'lodash';

import {
  PaymentPlanTier,
  TenantSchema,
  UserConfiguredUsageLimit,
} from '@/types/schema';

import { getCostForTraces } from './getCostForTraces';

export function isNil<T>(
  value: T | null | undefined
): value is null | undefined {
  return value === null || value === undefined;
}

export function getLimitTotals(
  workspaces: TenantSchema[],
  groupedUsageLimits: Dictionary<UserConfiguredUsageLimit[]>,
  tier?: PaymentPlanTier | null
) {
  return workspaces.reduce(
    (
      acc: {
        total: number | null;
        longlived: number | null;
        maxCost: number | null;
      },
      w
    ) => {
      const usageLimits = groupedUsageLimits[w.id];
      const totalLimit = usageLimits?.find(
        (s) => s.limit_type === 'monthly_traces'
      )?.limit_value;

      const longlivedLimit = usageLimits?.find(
        (s) => s.limit_type === 'monthly_longlived_traces'
      )?.limit_value;

      const maxCost = getCostForTraces(
        totalLimit ?? null,
        longlivedLimit ?? null,
        tier,
        acc.total ?? 0,
        acc.longlived ?? 0
      ).maxCostEstimate;

      if (isNil(totalLimit) || acc.total === null) {
        acc.total = null;
      } else {
        acc.total += totalLimit;
      }
      if (isNil(longlivedLimit) || acc.longlived === null) {
        acc.longlived = null;
      } else {
        acc.longlived += longlivedLimit;
      }
      if (isNil(maxCost) || acc.maxCost === null) {
        acc.maxCost = null;
      } else {
        acc.maxCost += maxCost;
      }

      return acc;
    },
    { total: 0, longlived: 0, maxCost: 0 }
  );
}
